 <mat-card-header>
    <mat-card-title>
      {{data.name}}
      <span *ngIf="!data.deactivate">löschen?</span>
      <span *ngIf="data.deactivate">deaktivieren?</span>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Möchten Sie {{data.name}} wirklich
    <span *ngIf="!data.deactivate">löschen?</span>
    <span *ngIf="data.deactivate">deaktivieren?</span>
  </mat-card-content>
  <mat-card-footer>
    <button mat-raised-button (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="warn" (click)="okay()" style="float: right;">
      <span *ngIf="!data.deactivate">Löschen</span>
      <span *ngIf="data.deactivate">Deaktivieren</span>
    </button>
  </mat-card-footer>
